import { NotificationVariants } from '@/types';
import React from 'react';

const Cloud: React.FC<{ variant: NotificationVariants }> = ({
  variant = NotificationVariants.SUCCESS
}) => {
  const stroke =
    variant === NotificationVariants.SUCCESS ? '#029389' : '#D0021B';
  return (
    <svg
      className="z-[12]"
      width="541"
      height="337"
      viewBox="0 0 541 337"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M437.562 134.8V136.8H439.562C494.486 136.8 539 181.175 539 235.9C539 290.625 494.486 335 439.562 335H135.25C61.6476 335 2 275.541 2 202.2C2 128.859 61.6476 69.4 135.25 69.4C151.718 69.4 167.426 72.5202 182 77.9759L183.703 78.6136L184.5 76.9783C206.089 32.6342 251.559 2 304.312 2C377.915 2 437.562 61.4587 437.562 134.8Z"
        fill="white"
        stroke={stroke}
        strokeWidth="4"
      />
    </svg>
  );
};

export default Cloud;
